import { Column } from "../../../components/TablePaginated/TablePaginated";

export const TableHeaderColumns: Column[] = [
  {
    label: "N° da nota",
    id: "document",
    align: "left",
  },
  {
    label: "Emissão",
    id: "dateOfIssue",
    align: "left",
    showIcon: true,
  },
  {
    label: "Cliente",
    id: "customerName",
    align: "left",
  },
  {
    label: "CNPJ",
    id: "CNPJ",
    align: "left",
  },
  {
    label: "Vencimento",
    id: "dueDate",
    align: "left",
    showIcon: true,
  },
  {
    label: "Status",
    id: "financialStatus",
    align: "left",
    showIcon: true,
  },
  {
    label: "Filial",
    id: "branch",
    align: "left",
    showIcon: true,
  },
  {
    label: "Valor",
    id: "value",
    align: "right",
    showIcon: true,
  },
  {
    label: "",
    id: "icon",
    align: "center",
  },
];
